var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "drawer-disclaimer" }, [
    _c("p", [
      _vm._v(
        "Da oggi puoi disegnare più aree contemporaneamente su mappa, per identificare le zone di tuo interesse!"
      )
    ]),
    _vm._v(" "),
    _c("img", {
      staticClass: "multi",
      attrs: { src: "/img/icons/" + _vm.$root.network + "/multi.svg" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }